import "../assets/HeaderIcon.css";
import { jsxs as h, jsx as c } from "preact/jsx-runtime";
import { c as d } from "./index.2w0W-O47.js";
const m = "_headerIcon_4od6h_1", _ = "_baseIcon_4od6h_8", I = "_badge_4od6h_15", g = "_number_4od6h_27", i = "_badgeIcon_4od6h_35", n = {
  headerIcon: m,
  baseIcon: _,
  badge: I,
  number: g,
  badgeIcon: i
}, x = ({
  iconElement: r,
  badge: e,
  href: t,
  ariaLabel: b,
  ...o
}) => {
  const s = [n.badge], l = !!e && (() => {
    let a;
    return typeof e == "number" ? (s.push(n.number), a = e > 99 ? "99+" : `${e}`) : (s.push(n.badgeIcon), a = e), /* @__PURE__ */ c("span", { class: d(s), "data-testid": "headerIcon-badge", children: a });
  })();
  return /* @__PURE__ */ h(
    "a",
    {
      href: t,
      "aria-label": b,
      ...o,
      class: d(n.headerIcon, o.class),
      children: [
        /* @__PURE__ */ c("span", { class: n.baseIcon, children: r }),
        l
      ]
    }
  );
};
export {
  x as H
};
